import {buffers, TakeableChannel} from "redux-saga";
import {PingAction} from "../state/types";
import {actionChannel, put, take} from "redux-saga/effects";
import {SourceAction} from "../state/source";
import {StatusRequiredAction} from "../state/status";


export function * Ping () {

    const channel: TakeableChannel<PingAction> = yield actionChannel(['PingBegin', "PingError"], buffers.sliding(1));

    yield put<SourceAction>({
        type: "Source",
        payload: {
            type: "Ping"
        }
    });

    const action:PingAction = yield take<PingAction>(channel);

    if (action.type === "PingError") {
        yield put<StatusRequiredAction>({
            type: "RequiredStatus",
            payload: "STOP"
        })
        return false;
    }
    return true;
}
